export default function ClonedVector() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
			<g stroke="#fff">
				<path d="m8 10 1.33 1.33L12 8.67" />
				<path d="M13.33 5.33H6.67c-.74 0-1.34.6-1.34 1.34v6.66c0 .74.6 1.34 1.34 1.34h6.66c.74 0 1.34-.6 1.34-1.34V6.67c0-.74-.6-1.34-1.34-1.34Z" />
				<path d="M2.67 10.67c-.74 0-1.34-.6-1.34-1.34V2.67c0-.74.6-1.34 1.34-1.34h6.66c.74 0 1.34.6 1.34 1.34" />
			</g>
		</svg>
	);
}
